module.exports = __webpack_public_path__ + "img/user.3089c7cf.png";